// extracted by mini-css-extract-plugin
export default {"modalContainer":"invoiceModal_modalContainer__UfrN7","closeButton":"invoiceModal_closeButton__tgcW7","dialog":"invoiceModal_dialog__nXWPc"};